import React from 'react';
import { Button } from '../ui/button';
import { Progress } from '../ui/progress';
import { LogOut, Sun, Moon, Building } from 'lucide-react';

export function ClientPortalHeader({ clientData, onLogout, isDark, onToggleTheme }) {
  return (
    <header className="bg-card border-b border-border sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="NewSlate" className="h-10 object-contain" />
          <span className="font-body text-xs text-accent uppercase tracking-wider ml-2">Client Portal</span>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right hidden sm:block">
            <p className="font-body text-sm font-medium text-foreground">{clientData?.case_name}</p>
            <p className="font-body text-xs text-muted-foreground">{clientData?.email}</p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggleTheme}
            className="text-muted-foreground hover:text-foreground"
            data-testid="client-theme-toggle-btn"
          >
            {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </Button>
          <Button variant="outline" size="sm" onClick={onLogout} className="font-body" data-testid="client-logout-btn">
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        </div>
      </div>
    </header>
  );
}

export function WelcomeBanner({ caseInfo, profileCompletion }) {
  const firstName = caseInfo.name ? caseInfo.name.split(' ')[0] : 'Client';
  const completionPercent = profileCompletion ? profileCompletion.overall.percent : 0;
  const isComplete = profileCompletion ? profileCompletion.is_complete : true;

  return (
    <div className="bg-gradient-to-r from-primary to-primary/80 rounded-2xl p-6 mb-8 text-white">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl font-bold mb-2">
            Welcome, {firstName}
          </h1>
          <p className="font-body text-white/80">
            View your case status, update your profile, and upload documents.
          </p>
        </div>
        {profileCompletion && (
          <div className="bg-white/20 rounded-xl p-4 min-w-[200px]">
            <div className="flex items-center justify-between mb-2">
              <span className="font-body text-sm">Profile Completion</span>
              <span className="font-body text-sm font-bold">{completionPercent}%</span>
            </div>
            <Progress value={completionPercent} className="h-2 bg-white/30" />
            {!isComplete && (
              <p className="font-body text-xs mt-2 text-white/70">
                Complete your profile for faster processing
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export function OrganizationFooter({ org }) {
  const orgName = org.name || 'Your Immigration Firm';
  const orgContact = org.contact_email || org.contact_phone || '';

  return (
    <div className="bg-card border border-border rounded-xl py-4 px-6 mt-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Building className="w-5 h-5 text-muted-foreground" />
          <div>
            <p className="font-body text-sm font-medium">{orgName}</p>
            <p className="font-body text-xs text-muted-foreground">{orgContact}</p>
          </div>
        </div>
        <p className="font-body text-xs text-muted-foreground">Powered by NewSlate</p>
      </div>
    </div>
  );
}
